/* unplugin-vue-components disabled */import script from "./upload-project-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./upload-project-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./upload-project-dialog.vue?vue&type=style&index=0&id=51429224&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51429224"]])

export default __exports__